export const PURPOSES_OF_DELETING_ACCOUNT = [
  {
    purpose: 'Something was broken',
    value: 'somethingBroken',
  },
  {
    purpose: 'I’m not getting any invites',
    value: 'noInvites',
  },
  {
    purpose: 'I have a privacy concern',
    value: 'privacyConcern',
  },
  {
    purpose: 'Other',
    value: 'other',
  },
];
